export default "__VITE_ASSET__hA3suBdj__"